import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateShift, deleteShift } from "../../stores/member/memberActions";
import Modal from "../Modal";
import i18n from "../../utils/i18n";
import ShiftForm from "./ShiftForm";

const EditShiftButton = ({ shift, event, memberTypeProperties }) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const handleClick = () => {
    setShowModal(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (shiftData) => {
    dispatch(updateShift({ ...shift, ...shiftData }));
    hideModal();
  };

  const handleDelete = () => {
    dispatch(deleteShift(shift.identifier || shift.id));
    hideModal();
  };

  return (
    <span>
      <button
        onClick={handleClick}
        className="btn btn-warning btn-block btn-xs add_shift_button"
      >
        {i18n.t("schedule.shifts.edit_shift")}
      </button>
      <Modal
        show={showModal}
        onHide={hideModal}
        title="Edit shift"
      >
        <ShiftForm
          onSubmitHandler={handleSubmit}
          onDeleteHandler={handleDelete}
          event={event}
          shift={shift}
          memberTypeProperties={memberTypeProperties}
        />
      </Modal>
    </span>
  );
};

export default EditShiftButton;

